import Swiper, { Navigation, Pagination } from 'swiper';

Swiper.use([Pagination, Navigation]);

class HomeSlider {
  public components: NodeListOf<Element>;
  public triggers: NodeListOf<Element>;
  public labelTriggers: NodeListOf<Element>;
  public labelTargets: NodeListOf<Element>;

  constructor() {
    this.components = document.querySelectorAll('[data-component="slider-pagination"]');
    this.triggers = document.querySelectorAll('[data-trigger="slider-pagination"]');
    this.labelTriggers = document.querySelectorAll('[data-trigger="slider-pagination-label"]');
    this.labelTargets = document.querySelectorAll('[data-target="slider-pagination-label"]');
    this._init();
  }

  _init() {
    this.triggers.forEach((trigger, index) => {
      if (!(trigger instanceof HTMLElement)) {
        return;
      }

      const timelineText = trigger.querySelectorAll('.timeline-slider__elements-hidden');
      const paginationEl = trigger.querySelector('.timeline-slider__pagination');
      const nextEl = trigger.querySelector('.swiper-button-next');
      const prevEl = trigger.querySelector('.swiper-button-prev');

      let swiper = new Swiper(trigger, {
        pagination: {
          el: paginationEl instanceof HTMLElement ? paginationEl : undefined,
          clickable: true,
          dynamicBullets: true,
          dynamicMainBullets: 1,
          renderBullet: function (index, className) {
            const text = timelineText[index].getAttribute('data-timeline');
            return `<div class="${className}"><span>${text}</span></div>`;
          }
        },
        breakpoints: {
          768: {
            pagination: {
              dynamicBullets: false
            }
          }
        },
        navigation: {
          nextEl: nextEl instanceof HTMLElement ? nextEl : undefined,
          prevEl: prevEl instanceof HTMLElement ? prevEl : undefined
        },
        preloadImages: false,
        lazy: {
          loadOnTransitionStart: true
        }
      });

      // If swiper is init before image is loaded, we reload swiper
      // (when lazyload images with data-visibility)
      const firstImage = trigger.querySelector('img');
      if (firstImage) {
        firstImage.onload = () => {
          if (swiper) {
            swiper.update();
          }
        };
      }
    });
  }
}

export const homeSlider = new HomeSlider();